const norwegianCurrencyFormatter = Intl.NumberFormat('no-NB', {
  currency: 'NOK',
  minimumFractionDigits: 0,
  style: 'currency',
});

const norwegianNumberFormatter = Intl.NumberFormat('no-NB', {
  minimumFractionDigits: 0,
  style: 'decimal',
});

export const formatNorwegianNumber = (value: number) =>
  norwegianNumberFormatter.format(value);

export const formatNorwegianCurrency = (value: number) =>
  norwegianCurrencyFormatter.format(value);

export const emptyIfZero = <T>(value: T | null | undefined) =>
  value == null || value === 0 ? undefined : value;

export const phoneNumberFormatter = (phoneNumber?: string) => {
  if (!phoneNumber || phoneNumber.length !== 11 || !phoneNumber.includes('+')) {
    return phoneNumber;
  }
  return phoneNumber.replace(
    /(.{3})(\d{2})(\d{2})(\d{2})(\d{2})/,
    '$1 $2 $3 $4 $5',
  );
};
